import { schema } from 'normalizr';

export const playerSchema = new schema.Entity('players');
export const playerListSchema = [ playerSchema ];



// WEBPACK FOOTER //
// ./src/schemas/player.js